(() => {
  const mobile = window.matchMedia('(max-width: 1024px)');
  const phone = window.matchMedia('(max-width: 749px)');

  function revealLinkedAnswer() {
    if (!phone.matches || !window.location.hash) return;
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
    const item = document.getElementById(id)?.closest('.wolf-faq__item');
    if (item) item.open = true;
  }

  function initializeFAQs() {
    if (!phone.matches) return;
    document.querySelectorAll('.wolf-faq__item').forEach(item => {
      if (item.dataset.wolfMobileFaqInitialized) return;
      item.dataset.wolfMobileFaqInitialized = 'true';
      item.open = false;
    });
    revealLinkedAnswer();
  }

  function initializeMenus() {
    document.querySelectorAll('.wolf-header__mobile').forEach(menu => {
      if (menu.dataset.wolfMobileMenuInitialized) return;
      menu.dataset.wolfMobileMenuInitialized = 'true';
      const summary = menu.querySelector('summary');
      const panel = menu.querySelector('.wolf-header__mobile-panel');
      if (!summary || !panel) return;

      const sync = () => {
        if (!menu.isConnected) return;
        summary.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
        summary.setAttribute('aria-expanded', String(menu.open));
        document.documentElement.classList.toggle('wolf-mobile-menu-open', mobile.matches && Boolean(document.querySelector('.wolf-header__mobile[open]')));
      };
      const close = (restoreFocus = false) => {
        menu.open = false;
        sync();
        if (restoreFocus) summary.focus();
      };

      menu.addEventListener('toggle', sync);
      // Close before a delegated cart handler opens its own focus trap.
      document.addEventListener('click', event => {
        if (!menu.open) return;
        if (!menu.contains(event.target) || event.target.closest('a')) close();
      }, true);
      document.addEventListener('keydown', event => {
        if (!menu.open || !mobile.matches) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        } else if (event.key === 'Tab') {
          const controls = [summary, ...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')].filter(control => !control.hidden && !control.closest('[hidden]'));
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      mobile.addEventListener('change', () => close());
      sync();
    });
  }

  function initialize() {
    initializeMenus();
    initializeFAQs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('hashchange', revealLinkedAnswer);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.wolf-header__mobile[open]').forEach(menu => { menu.open = false; });
    document.documentElement.classList.toggle('wolf-mobile-menu-open', mobile.matches && Boolean(document.querySelector('.wolf-header__mobile[open]')));
  });
})();
